import trans from './helper/i18n'
export default [
  {
    path: '/common/legal-bases',
    title: trans('generic.legal_bases.title'),
    name: 'legal_bases',
    camelName: 'LegalBase',
    endpoint: 'legal-bases',
    allQuery: 'LEGAL_BASES',
    singleQuery: 'LEGAL_BASE',
    allQueryResolve: 'legalBases',
    singleQueryResolve: 'legalBasis',
    casts: {
      title: (item) => {
        return `${item.name} (${item.law})`
      },
    },
    fields: [
      {
        key: 'name',
        label: trans('generic.legal_bases.fields.name'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'law',
        label: trans('generic.legal_bases.fields.law'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'description',
        label: trans('generic.legal_bases.fields.description'),
        type: 'textarea',
        default: '',
        required: false,
      },
    ],
  },
  {
    path: '/common/personal-data-types',
    title: trans('generic.personal_data_types.title'),
    name: 'personal_data_types',
    camelName: 'PersonalDataType',
    endpoint: 'personal-data-types',
    allQuery: 'PERSONAL_DATA_TYPES',
    allQueryResolve: 'personalDataTypes',
    singleQuery: 'PERSONAL_DATA_TYPE',
    singleQueryResolve: 'personalDataType',
    casts: {
      title: (item) => {
        return item.name
      },
    },
    fields: [
      {
        key: 'name',
        label: trans('generic.personal_data_types.fields.name'),
        type: 'text',
        default: '',
        required: true,
        validation: 'required|alpha',
      },
      {
        key: 'description',
        label: trans('generic.personal_data_types.fields.description'),
        type: 'textarea',
        default: '',
        required: false,
        validation: 'required',
      },
      {
        key: 'is_sensible',
        label: trans('generic.personal_data_types.fields.isSensible'),
        type: 'boolean',
        default: false,
        required: false,
        validation: null,
      },
    ],
  },
  {
    path: '/common/subjects',
    title: trans('generic.subjects.title'),
    name: 'subjects',
    camelName: 'Subjects',
    endpoint: 'subjects',
    allQuery: 'SUBJECTS',
    allQueryResolve: 'subjects',
    singleQuery: 'SUBJECT',
    singleQueryResolve: 'subject',
    casts: {
      title: (item) => {
        return item.name
      },
    },
    fields: [
      {
        key: 'name',
        label: trans('generic.subjects.fields.name'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'description',
        label: trans('generic.subjects.fields.description'),
        type: 'textarea',
        default: '',
        required: false,
      },
    ],
  },
  {
    path: '/common/contact-people',
    title: trans('generic.contact_people.title'),
    name: 'contact_people',
    camelName: 'ContactPeople',
    endpoint: 'contact-people',
    allQuery: 'CONTACT_PEOPLE',
    allQueryResolve: 'contactPersons',
    singleQuery: 'CONTACT_PERSON',
    singleQueryResolve: 'contactPerson',
    casts: {
      title: (item) => {
        return item.first_name + ' ' + item.last_name
      },
    },
    fields: [
      {
        key: 'first_name',
        label: trans('generic.contact_people.fields.firstName'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'last_name',
        label: trans('generic.contact_people.fields.lastName'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'department',
        label: trans('generic.contact_people.fields.department'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'email_adress',
        label: trans('generic.contact_people.fields.emailAdress'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'phone_number',
        label: trans('generic.contact_people.fields.phoneNumber'),
        type: 'text',
        default: '',
        required: false,
      },
    ],
  },
  {
    path: '/common/internal-recipients',
    title: trans('generic.internal_recipients.title'),
    name: 'internal_recipients',
    camelName: 'InternalRecipient',
    endpoint: 'internal-recipients',
    allQuery: 'INTERNAL_RECIPIENTS',
    allQueryResolve: 'internalRecipients',
    singleQuery: 'INTERNAL_RECIPIENT',
    singleQueryResolve: 'internalRecipient',
    casts: {
      title: (item) => {
        return item.department
      },
    },
    fields: [
      {
        key: 'department',
        label: trans('generic.internal_recipients.fields.department'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'description',
        label: trans('generic.internal_recipients.fields.description'),
        type: 'textarea',
        default: '',
        required: false,
      },
    ],
  },
  {
    path: '/common/external-recipients',
    title: trans('generic.external_recipients.title'),
    name: 'external_recipients',
    camelName: 'ExternalRecipient',
    endpoint: 'external-recipients',
    allQuery: 'EXTERNAL_RECIPIENTS',
    allQueryResolve: 'externalRecipients',
    singleQuery: 'EXTERNAL_RECIPIENT',
    singleQueryResolve: 'externalRecipient',
    casts: {
      title: (item) => {
        return item.name
      },
    },
    fields: [
      {
        key: 'name',
        label: trans('generic.external_recipients.fields.name'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'description',
        label: trans('generic.external_recipients.fields.description'),
        type: 'textarea',
        default: '',
        required: false,
      },
    ],
  },
  {
    path: '/common/safeguards',
    title: trans('generic.safeguards.title'),
    name: 'safeguards',
    camelName: 'Safeguard',
    endpoint: 'safeguards',
    allQuery: 'SAFEGUARDS',
    allQueryResolve: 'safeguards',
    singleQuery: 'SAFEGUARD',
    singleQueryResolve: 'safeguard',
    casts: {
      title: (item) => {
        return item.name
      },
    },
    fields: [
      {
        key: 'name',
        label: trans('generic.safeguards.fields.name'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'description',
        label: trans('generic.safeguards.fields.description'),
        type: 'textarea',
        default: '',
        required: false,
      },
    ],
  },
  {
    path: '/common/deletion-deadlines',
    title: trans('generic.deletion_deadlines.title'),
    name: 'deletion_deadlines',
    camelName: 'DeletionDeadline',
    endpoint: 'deletion-deadlines',
    allQuery: 'DELETION_DEADLINES',
    allQueryResolve: 'deletionDeadlines',
    singleQuery: 'DELETION_DEADLINE',
    singleQueryResolve: 'deletionDeadline',
    casts: {
      title: (item) => {
        return item.name
      },
    },
    fields: [
      {
        key: 'name',
        label: trans('generic.deletion_deadlines.fields.name'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'duration',
        label: trans('generic.deletion_deadlines.fields.duration'),
        type: 'text',
        default: '',
        required: true,
      },
      {
        key: 'description',
        label: trans('generic.deletion_deadlines.fields.description'),
        type: 'textarea',
        default: '',
        required: false,
      },
    ],
  },
]
